/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateAdminDto = {
    name: string;
    username: string;
    password: string;
    hometown?: string;
    birthday?: string;
    gender?: CreateAdminDto.gender;
    address?: string;
    images?: Array<string>;
};

export namespace CreateAdminDto {

    export enum gender {
        '_0' = 0,
        '_1' = 1,
        '_3' = 3,
    }


}

